export const PUBLIC_IMAGE_PATH = "/assets/images/";